import { trigger, state, style, transition, animate } from '@angular/animations'
import { Component } from '@angular/core'

@Component({
  selector: 'basin-pull-down-container',
  templateUrl: './pull-down-container.component.html',
  styleUrl: './pull-down-container.component.scss',
  animations: [
    trigger('expandCollapse', [
      state('open', style({ height: '*', opacity: 1 })),
      state('closed', style({ height: '0px', opacity: 0, overflow: 'hidden' })),
      transition('closed => open', [
        animate('300ms ease-out'), // Adjust speed as needed
      ]),
      transition('open => closed', [
        animate('200ms ease-in'), // Adjust speed as needed
      ]),
    ]),
  ],
})
export class PullDownContainerComponent {
  visibleDropbar: boolean = false

  toggleDropbar() {
    this.visibleDropbar = !this.visibleDropbar
  }
}
